import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-verification-error',
  templateUrl: './verification-error.component.html',
  styleUrls: ['./verification-error.component.scss']
})
export class VerificationErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
